import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NorwayCaseSummary } from '../../interfaces/norwayCaseSummary.interface';
import { ErrorModalService } from '../../modal/error.modal.service';
import { NorgeApplicationService } from '../norge-application.service';

@Component({
    selector: 'app-norge-case-search',
    templateUrl: './norge-case-search.component.html',
    styleUrls: ['./norge-case-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NorgeCaseSearchComponent implements OnInit {
  public form: FormGroup;

  public get searchQueryField() { return this.form.get('searchQuery'); }
  public get selectedCase(): NorwayCaseSummary | null { return this.norgeApplicationService.selectedCase; }
  public isSearching = false;
  public searched = false;
  public searchResults: NorwayCaseSummary[] | null = null;
  public readonly skeletonRows = [1, 2, 3];

  public get showResults(): boolean {
    return this.searched && !this.isSearching && this.searchResults !== null;
  }

  constructor(
    private norgeApplicationService: NorgeApplicationService,
    private formBuilder: FormBuilder,
    private errorModalService: ErrorModalService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      searchQuery: ['', [Validators.required, Validators.minLength(2)]]
    });
  }

  public search(): void {
    if (this.isSearching) { return; }

    this.form.patchValue({ searchQuery: (this.searchQueryField?.value as string ?? '').trim() });

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSearching = true;
    this.searched = true;
    this.searchResults = null;

    const query = this.searchQueryField?.value as string;

    this.norgeApplicationService.searchCases(query).subscribe(
      (results: NorwayCaseSummary[]) => {
        this.isSearching = false;
        this.searchResults = results ?? [];
      },
      () => {
        this.isSearching = false;
        this.errorModalService.open(this.translate.instant('norge.soknad.sok-feil-tittel'), this.translate.instant('norge.soknad.sok-feil'));
      }
    );
  }

  public selectCase(result: NorwayCaseSummary): void {
    this.norgeApplicationService.selectedCase = result;
  }

  public changeCase(): void {
    this.norgeApplicationService.selectedCase = null;
  }

  public trackByCaseId(index: number, item: NorwayCaseSummary): string {
    return item.caseId;
  }
}
